import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(m[1]);

        (async () => {
            try {
                const r = await api.post("/auth/session", { session_id });
                setUser(r.data);
                // clear hash and go to board
                window.history.replaceState(null, "", "/board");
                navigate("/board", { replace: true, state: { user: r.data } });
            } catch (e) {
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center" data-testid="auth-callback">
                <div className="w-12 h-12 border-2 border-black border-t-transparent rounded-full animate-spin mx-auto" />
                <p className="mt-6 label-eyebrow text-neutral-500">Iniciando sesión</p>
            </div>
        </div>
    );
}
